module.exports = __webpack_public_path__ + "static/0077-25d3e79bc9f2d168c900c6c67b451a20.png";